import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import MapWrapper from '../mapWrapper'
import { setMapDisplayMode, setMapZoom, dispatchInteractiveMapClicked } from '../mapActions'
import { cancelHideVideoUITimer } from 'aria-viewer/players/videoplayer/actions/videoActions'
import MapDisplayModes from '../MapDisplayModes'
import $ from 'jquery'

import { SCREEN_SIZES } from 'aria-viewer/tour/constants'
import MapDefaultButton from '../components/buttons/mapDefault'
import MapShrinkButton from '../components/buttons/mapShrink'
import MapFullscreenButton from '../components/buttons/mapFullscreen'
import MapZoomButton from '../components/buttons/mapZoom'
import MapTypeButton from '../components/buttons/mapType'
import Browser from 'aria-viewer/utils/mobileDetect'
import { MAIN_MAP_INDEX } from 'aria-viewer/keyboard/constants/tabIndices'

import INTERACTIVE_MAP from 'public/assets/svg/interactive_map.svg'
import ZoomPlus from 'public/assets/svg/zoom_map_plus.svg'
import ZoomMinus from 'public/assets/svg/zoom_map_minus.svg'
import FullScreen from 'public/assets/svg/full_screen.svg'
import CloseFullScreen from 'public/assets/svg/close_fullscreen.svg'
import SmallVersion from 'public/assets/svg/small_version.svg'
import NoMapSmallVersion from 'public/assets/svg/no_map_small_version.svg'

import compose from 'recompose/compose'

//Manage the map's position
const mapPosition = {
    default: {
        position: 'absolute',
        left: 0,
        bottom: 88,
    },
}
const mapTransition = `all ${styleguide.delay.normal}`
//The look for each mode
const MODE_STYLE = {
    [MapDisplayModes.COLLAPSED]: Object.assign({}, mapPosition.default, {
        width: 35.5,
        height: 40,
    }),
    [MapDisplayModes.DEFAULT]: Object.assign({}, mapPosition.default, {
        width: 212,
        height: 119,
    }),
    [MapDisplayModes.EXPANDED]: Object.assign({}, mapPosition.default, {
        width: 400,
        height: 360,
    }),
    [MapDisplayModes.FULLSCREEN]: Object.assign({}, mapPosition.default, {
        width: '100%',
        height: 'calc(100% - 60px)',
        left: 0,
        bottom: 0,
        transform: 'translate3d(0,0,1px)',
    }),
}

const zoomContainer = {
    height: '64px',
    width: '32px',
    borderRadius: '4px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 2px 3px 0 rgba(0,0,0,0.2)',
    marginRight: '20px',
    marginBottom: '2px',
    position: 'absolute',
    bottom: '15px',
    right: '0px',
    zIndex: '1000',
}
//Setup button styles
const defaultButtonStyle = {
    position: 'absolute',
    background: styleguide.colors.grey_8,
    zIndex: '1000',
    width: '24px',
    height: '24px',
}
const dividerContainer = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}
const divider = {
    boxSizing: 'border-box',
    height: '1px',
    width: '18px',
    border: '1px solid #B4BBC3',
    backgroundColor: '#D8D8D8',
}
const buttonStyle = {
    default: Object.assign({}, defaultButtonStyle, {
        bottom: 0,
        left: 0,
        width: 35.5,
        height: 40,
        opacity: 0.8,
    }),
    collapse: Object.assign({}, defaultButtonStyle, {
        bottom: 0,
        left: 0,
    }),
    fullscreen: Object.assign({}, defaultButtonStyle, {
        top: 0,
        right: 0,
    }),
    zoomIn: {
        bottom: 36,
        right: 10,
    },
    zoomOut: {
        bottom: 10,
        right: 10,
    },
}
class MapFloatingContainer extends PureComponent {
    constructor(props) {
        super(props)

        this.state = {
            blockingMouseOver: false,
            loc_id: null,
            tourid: null,
            stopid: null,
            mapType: 'roadmap',
        }

        this.R = {
            mapFloatingContainer: undefined,
        }

        this.setModeCollapsed = this.setModeCollapsed.bind(this)
        this.setModeDefault = this.setModeDefault.bind(this)
        this.setModeExpanded = this.setModeExpanded.bind(this)
        this.setModeFullscreen = this.setModeFullscreen.bind(this)
        this.zoomIn = this.zoomIn.bind(this)
        this.zoomOut = this.zoomOut.bind(this)
        this.handleMouseOver = this.handleMouseOver.bind(this)
        this.handleMouseOut = this.handleMouseOut.bind(this)
        this.handleOnClick = this.handleOnClick.bind(this)
        this.closeExpanded = this.closeExpanded.bind(this)
        this.handleMapZoom = this.handleMapZoom.bind(this)
        this.changeMapType = this.changeMapType.bind(this)
    }
    init(props) {
        const {
            loading,
            setMapDisplayMode,
            tourid,
            location: { loc_id },
            currentStop: { stopid },
            mapDisplayMode,
            sizes,
        } = props

        if (!loading && (this.state.loc_id != loc_id || this.state.tourid != tourid)) {
            if (Browser.tablet() || sizes.width <= SCREEN_SIZES.size_1024) {
                setMapDisplayMode(MapDisplayModes.COLLAPSED)
            } else {
                setMapDisplayMode(MapDisplayModes.DEFAULT)
            }
            this.setState({ loc_id, tourid, stopid })
        } else if (stopid != this.state.stopid) {
            if (mapDisplayMode == MapDisplayModes.FULLSCREEN) {
                setMapDisplayMode(MapDisplayModes.DEFAULT)
            }
            this.setState({ stopid })
        }
    }
    componentDidMount() {
        this.init(this.props)
    }
    componentWillReceiveProps(newProps) {
        this.init(newProps)
    }
    setModeCollapsed() {
        this.props.setMapDisplayMode(MapDisplayModes.COLLAPSED)
    }
    setModeDefault() {
        clearTimeout(this.defaultModeTimeout)
        this.setState({ blockingMouseOver: true })
        this.defaultModeTimeout = setTimeout(() => {
            this.setState({ blockingMouseOver: false })
        }, parseInt(styleguide.delay.mainMediaTransition))
        this.props.setMapDisplayMode(MapDisplayModes.DEFAULT)
    }
    setModeExpanded() {
        if (this.props.mapDisplayMode == MapDisplayModes.DEFAULT) {
            this.props.setMapDisplayMode(MapDisplayModes.EXPANDED)
        }
    }
    setModeFullscreen() {
        this.props.setMapDisplayMode(MapDisplayModes.FULLSCREEN)
    }
    closeExpanded() {
        if (this.props.mapDisplayMode == MapDisplayModes.EXPANDED) {
            this.props.setMapDisplayMode(MapDisplayModes.DEFAULT)
        }
    }
    zoomIn() {
        const max = this.props.mapZoomBounds.get('max')
        const level = this.props.mapZoomBounds.get('level') + 1
        if (level <= max) {
            this.props.setMapZoom({ level })
        }
    }
    zoomOut() {
        const min = this.props.mapZoomBounds.get('min')
        const level = this.props.mapZoomBounds.get('level') - 1
        if (level >= min) {
            this.props.setMapZoom({ level })
        }
    }
    changeMapType(mapType) {
        this.setState({ mapType })
    }
    handleMapZoom({ level }) {
        if (level != this.props.mapZoomBounds.get('level')) {
            this.props.setMapZoom({ level })
        }
    }
    handleMouseOver(e) {
        if (this.props.mapDisplayMode == MapDisplayModes.DEFAULT && !this.state.blockingMouseOver) {
            this.props.cancelHideVideoUITimer()
            clearTimeout(this.mouseOutTimeout)
            this.setModeExpanded()
        }
    }
    handleMouseOut(e) {
        if (
            this.props.mapDisplayMode == MapDisplayModes.EXPANDED &&
            $(e.relatedTarget).parents('.mapFloatingContainer').length == 0
        ) {
            const { setMapDisplayMode } = this.props

            clearTimeout(this.mouseOutTimeout)
            this.mouseOutTimeout = setTimeout(() => {
                setMapDisplayMode(MapDisplayModes.DEFAULT)
            }, parseInt(styleguide.delay.fast))
        }
    }
    handleOnClick() {
        if (Browser.tablet()) {
            this.setModeExpanded()
        }
    }
    expandedStateMask() {
        const { mapDisplayMode } = this.props

        return this.state.blockingMouseOver ||
            mapDisplayMode == MapDisplayModes.EXPANDED ||
            mapDisplayMode == MapDisplayModes.FULLSCREEN ? (
            <div
                style={{
                    position: 'absolute',
                    width: this.props.viewportWidth,
                    height: '100%',
                    transition: mapTransition,
                    background: styleguide.colors.grey_8,
                    opacity: mapDisplayMode == MapDisplayModes.FULLSCREEN ? 1 : 0,
                    zIndex: 1000,
                }}
                onClick={this.closeExpanded}
            />
        ) : null
    }
    addInteractiveMapButton() {
        const {
            isInteractiveMap,
            tourid,
            location: { inst_unique_id, loc_id },
            dispatchInteractiveMapClicked,
        } = this.props

        const plArr = /pl=(\w+)/g.exec(window.location.search)

        const pl = (plArr && plArr[1]) || null

        return isInteractiveMap ? (
            <a
                target="_blank"
                href={`/tour/map/${inst_unique_id}/${loc_id}?tourId=${tourid}${pl ? '&pl=' + pl : ''}`}
                onClick={dispatchInteractiveMapClicked}
                onKeyDown={dispatchInteractiveMapClicked}
                aria-label={'Open Interactive Map'}
                style={Object.assign(
                    {},
                    {
                        position: 'absolute',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        bottom: 10,
                        zIndex: '1000',
                        width: 152,
                        height: 40,
                        borderRadius: 4,
                        boxShadow: '0 1px 4px 0 rgba(0,0,0,0.3)',
                        background: '#085FE5',
                    }
                )}
                rel="noreferrer"
                tabIndex={MAIN_MAP_INDEX}
            >
                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        width: '100%',
                        transform: 'translateY(-50%)',
                        color: '#fff',
                        textAlign: 'center',
                        fontSize: 14,
                        color: '#FFFFFF',
                        fontWeight: '500',
                    }}
                >
                    <img
                        style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '8px' }}
                        src={INTERACTIVE_MAP}
                    />
                    Interactive Map
                </div>
            </a>
        ) : null
    }
    addUIElements(hasGoogleMap) {
        const level = this.props.mapZoomBounds.get('level')
        const zoomInDisabled = this.props.mapZoomBounds.get('max') == level
        const zoomOutDisabled = this.props.mapZoomBounds.get('min') == level

        switch (this.props.mapDisplayMode) {
            case MapDisplayModes.COLLAPSED:
                return <MapDefaultButton onClick={this.setModeDefault} style={buttonStyle.default} />
            case MapDisplayModes.DEFAULT:
                return (
                    <div>
                        {this.props.isInteractiveMap && this.addInteractiveMapButton()}
                        <MapShrinkButton onClick={this.setModeCollapsed} style={buttonStyle.collapse} />
                    </div>
                )
            case MapDisplayModes.EXPANDED:
                return (
                    <div>
                        <MapShrinkButton onClick={this.setModeCollapsed} style={buttonStyle.collapse} />
                        <MapFullscreenButton onClick={this.setModeFullscreen} icon={FullScreen} />
                        {this.props.isInteractiveMap && this.addInteractiveMapButton()}
                        <div style={zoomContainer}>
                            <MapZoomButton onClick={this.zoomIn} icon={ZoomPlus} disabled={zoomInDisabled} />
                            <div style={dividerContainer}>
                                <div style={divider} />
                            </div>
                            <MapZoomButton onClick={this.zoomOut} icon={ZoomMinus} disabled={zoomOutDisabled} />
                        </div>
                        {hasGoogleMap && <MapTypeButton onClick={this.changeMapType} mapType={this.state.mapType} />}
                    </div>
                )
            case MapDisplayModes.FULLSCREEN:
                return (
                    <div>
                        <MapFullscreenButton onClick={this.setModeDefault} icon={CloseFullScreen} />
                        <div style={zoomContainer}>
                            <MapZoomButton onClick={this.zoomIn} icon={ZoomPlus} disabled={zoomInDisabled} />
                            <div style={dividerContainer}>
                                <div style={divider} />
                            </div>
                            <MapZoomButton onClick={this.zoomOut} icon={ZoomMinus} disabled={zoomOutDisabled} />
                        </div>
                        {hasGoogleMap && <MapTypeButton onClick={this.changeMapType} mapType={this.state.mapType} />}
                    </div>
                )
        }
    }

    setupKeyboardInteraction = () => {
        this.R.mapFloatingContainer &&
            this.R.mapFloatingContainer.querySelectorAll('*').forEach(childNode => (childNode.tabIndex = -1))
    }

    render() {
        const { isMapEnabled, mapDisplayMode, sizes, mapData } = this.props
        const mapAnimationSpeed =
            mapDisplayMode == MapDisplayModes.EXPANDED ? styleguide.delay.normal : styleguide.delay.slow
        const widthOverride = mapDisplayMode == MapDisplayModes.FULLSCREEN ? { width: this.props.viewportWidth } : {}
        const largeScreen = sizes.width >= SCREEN_SIZES.size_1350
        const hasGoogleMap = !mapData || !mapData.tiles || mapData.tiles.length === 0
        return isMapEnabled ? (
            <div>
                {this.expandedStateMask()}
                <div
                    id="mapFloat"
                    className="mapFloatingContainer"
                    ref={c => (this.R.mapFloatingContainer = c)}
                    style={Object.assign(
                        {},
                        MODE_STYLE[mapDisplayMode],
                        {
                            zIndex: 2000,
                            overflow: 'hidden',
                            transition: mapTransition,
                            // boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)',
                        },
                        widthOverride,
                        mapDisplayMode == MapDisplayModes.DEFAULT && largeScreen
                            ? {
                                  width: MODE_STYLE[mapDisplayMode].width * 1.17,
                                  height: MODE_STYLE[mapDisplayMode].height * 1.33,
                              }
                            : {}
                    )}
                    onMouseOver={this.handleMouseOver}
                    onMouseOut={this.handleMouseOut}
                    onClick={this.handleOnClick}
                    tabIndex={'-1'}
                >
                    {hasGoogleMap &&
                        this.props.mapDisplayMode == MapDisplayModes.DEFAULT &&
                        !this.props.mapIsAlreadyExpanded &&
                        this.props.isInteractiveMap && (
                            <img
                                src={SmallVersion}
                                style={{ outline: 'none', filter: 'blur(3px)', color: 'rgba(255,255,255, 0.9)' }}
                            />
                        )}
                    {hasGoogleMap &&
                        this.props.mapDisplayMode == MapDisplayModes.DEFAULT &&
                        !this.props.mapIsAlreadyExpanded &&
                        !this.props.isInteractiveMap && (
                            <img
                                src={NoMapSmallVersion}
                                style={{ outline: 'none', filter: 'blur(3px)', color: 'rgba(255,255,255, 0.9)' }}
                            />
                        )}
                    {(this.props.mapDisplayMode != MapDisplayModes.DEFAULT ||
                        this.props.mapIsAlreadyExpanded ||
                        !hasGoogleMap) && (
                        <MapWrapper
                            isInteractiveMap={this.props.isInteractiveMap}
                            visible={true}
                            hideCloseButton={true}
                            options={{
                                zoomControl: false,
                                disableDoubleClickZoom: true,
                                backgroundColor: styleguide.colors.map_background_color,
                                onZoom: this.handleMapZoom,
                                allowMapTypeControl:
                                    MapDisplayModes.EXPANDED == mapDisplayMode ||
                                    MapDisplayModes.FULLSCREEN == mapDisplayMode,
                            }}
                            mapType={this.state.mapType}
                            sizes={sizes}
                            wrapperStyle={{
                                opacity: mapDisplayMode == MapDisplayModes.COLLAPSED ? 0 : 100,
                                transition: `all ${mapAnimationSpeed}`,
                            }}
                            platform={{
                                mobile: false,
                                tablet: false,
                            }}
                            onMapReady={this.setupKeyboardInteraction}
                        />
                    )}
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                        }}
                    >
                        {this.addUIElements(hasGoogleMap)}
                    </div>
                </div>
            </div>
        ) : null
    }
}

export default compose(
    connect(
        mapSelectorsToProps([
            'isMapEnabled',
            'mapData',
            'isInteractiveMap',
            'loading',
            'mapDisplayMode',
            'location',
            'tourid',
            'currentStop',
            'mapZoomBounds',
            'viewportWidth',
        ]),
        {
            setMapDisplayMode,
            setMapZoom,
            dispatchInteractiveMapClicked,
            cancelHideVideoUITimer,
        }
    ),
    connect(state => ({
        mapIsAlreadyExpanded: state.getIn(['map', 'mapIsAlreadyExpanded']),
    }))
)(MapFloatingContainer)
